import type { CSSProperties } from "react";
import type { RasterImageSet } from "@/generated/raster-images";
import { cn } from "@/lib/utils";

export type ResponsiveImageProps = {
  image: RasterImageSet;
  alt: string;
  className?: string;
  style?: CSSProperties;
  sizes?: string;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
  draggable?: boolean;
};

export function ResponsiveImage({
  image,
  alt,
  className,
  style,
  sizes = "(max-width: 1023px) 100vw, (max-width: 1535px) 90vw, 1280px",
  loading = "lazy",
  fetchPriority,
  draggable,
}: ResponsiveImageProps) {
  return (
    <picture>
      <source srcSet={image.avifSrcSet} sizes={sizes} type="image/avif" />
      <source srcSet={image.webpSrcSet} sizes={sizes} type="image/webp" />
      <img
        src={image.fallback}
        alt={alt}
        width={image.width}
        height={image.height}
        className={className}
        style={style}
        sizes={sizes}
        loading={loading}
        decoding="async"
        fetchPriority={fetchPriority}
        draggable={draggable}
      />
    </picture>
  );
}
